export const setFlow = flow => ({
  type: 'SET_FLOW',
  flow: flow
})
